import {
  dateFormat,
  fileNameFormat,
  hourFormat,
} from "../../../../services/Utils/functionService";
import { downloadDoc, openDoc } from "../../../../services/Api/documentService";
import Eye from "../../../../assets/icons/eye.svg";
import Download from "../../../../assets/icons/download.svg";
import Trash from "../../../../assets/icons/trash.svg";
import { usePartnerRequestDetailsStore } from "../../../../stores/Cac/Partner/partnerRequestDetails";
import { usePartnerRequestsStore2 } from "../../../../stores/Cac/Partner/partnerRequests";

const PartnerDocumentTable = ({ onDeleteDoc }: any) => {
  // Store
  const { request } = usePartnerRequestDetailsStore();
  const { missionData } = usePartnerRequestsStore2();

  return (
    <div className="relative m-auto flex h-full w-full flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-lg shadow-slate-900/5">
      <div className="z-10 flex flex-shrink-0 items-center justify-between border-b border-slate-200 bg-white/95 px-4 py-3 backdrop-blur-sm sm:px-5 sm:py-4">
        <div className="min-w-0">
          <p className="text-base font-semibold text-slate-800 sm:text-lg">
            Documents déposés
          </p>
          <p className="mt-0.5 text-xs text-slate-500 sm:text-sm">
            Fichiers associés à cette requête
          </p>
        </div>
        <span className="ml-3 inline-flex h-8 min-w-8 flex-shrink-0 items-center justify-center rounded-full bg-light-lavender px-2.5 text-sm font-semibold text-slate-700">
          {request?.Documents?.length ?? 0}
        </span>
      </div>

      {!request?.Documents || request?.Documents.length === 0 ? (
        <div className="flex min-h-52 flex-1 flex-col items-center justify-center px-6 py-10 text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">
            <svg
              className="h-7 w-7"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5A3.375 3.375 0 0010.125 2.25H8.25m0 12.75h7.5m-7.5 3h4.5M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
              />
            </svg>
          </div>
          <p className="font-semibold text-slate-700">Aucun document déposé</p>
          <p className="mt-1 max-w-xs text-sm text-slate-500">
            Les documents ajoutés à la requête apparaîtront ici.
          </p>
        </div>
      ) : (
        <div className="flex flex-1 flex-col gap-2 overflow-y-auto bg-slate-50/70 p-2 sm:p-3">
          {request?.Documents.map(
            (document: {
              filename: string;
              type: string;
              createdAt: string;
              id: number;
              user: string;
            }) => (
              <div
                key={document?.id}
                className="group relative w-full rounded-xl border border-slate-200 bg-white p-2.5 shadow-sm transition-all duration-200 hover:border-slate-300 hover:shadow-md sm:p-3"
              >
                <div className="flex min-w-0 items-center gap-2.5">
                  <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-light-lavender text-slate-600">
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5A3.375 3.375 0 0010.125 2.25H8.25m6.75 12H9m3 3H9m1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                      />
                    </svg>
                  </div>

                  <div className="min-w-0 flex-1">
                    <p
                      className="truncate text-sm font-semibold leading-tight text-slate-800 sm:text-base"
                      title={fileNameFormat(document?.filename)}
                    >
                      {fileNameFormat(document?.filename)}
                    </p>

                    <div className="mt-1.5 flex min-w-0 items-center gap-2 overflow-hidden text-xs text-slate-500">
                      <span className="inline-flex min-w-0 items-center gap-1.5">
                        <svg
                          className="h-3.5 w-3.5 flex-shrink-0"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M6.75 3v2.25M17.25 3v2.25M3.75 18.75V7.5a2.25 2.25 0 012.25-2.25h12A2.25 2.25 0 0120.25 7.5v11.25M3.75 18.75A2.25 2.25 0 006 21h12a2.25 2.25 0 002.25-2.25M3.75 18.75v-7.5h16.5v7.5"
                          />
                        </svg>
                        <span className="truncate">
                          {dateFormat(document?.createdAt)} à{" "}
                          {hourFormat(document?.createdAt)}
                        </span>
                      </span>
                      <span className="hidden min-w-0 items-center gap-1.5 sm:inline-flex">
                        <span aria-hidden="true">•</span>
                        <span className="truncate" title={document?.user}>
                          {document?.user}
                        </span>
                      </span>
                      <span className="flex-shrink-0 rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-600">
                        {document?.type}
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-shrink-0 items-center gap-1.5">
                    {document.type === "xlsx" || document.type === "zip" ? (
                      <></>
                    ) : (
                      <button
                        type="button"
                        className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg border border-slate-200 bg-white transition-all duration-200 hover:border-blue-200 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-200"
                        onClick={() => {
                          openDoc(request?.id, document.id);
                        }}
                        title="Visualiser le document"
                        aria-label="Visualiser le document"
                      >
                        <img src={Eye} alt="visualisation" className="h-4 w-4" />
                      </button>
                    )}
                    <button
                      type="button"
                      className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg border border-slate-200 bg-white transition-all duration-200 hover:border-blue-200 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-200"
                      onClick={() => {
                        downloadDoc(
                          request?.id,
                          document.id,
                          document.filename
                        );
                      }}
                      title="Télécharger le document"
                      aria-label="Télécharger le document"
                    >
                      <img
                        src={Download}
                        alt="téléchargement"
                        className="h-4 w-4"
                      />
                    </button>
                    {request?.State?.state === "Accepté" ? (
                      <></>
                    ) : (
                      <button
                        type="button"
                        disabled={missionData?.closed === 1}
                        className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg border border-slate-200 bg-white transition-all duration-200 hover:border-red-200 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-200 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-slate-200 disabled:hover:bg-white"
                        onClick={() => onDeleteDoc(request?.id, document.id)}
                        title="Supprimer le document"
                        aria-label="Supprimer le document"
                      >
                        <img
                          className="h-4 w-4"
                          src={Trash}
                          alt="suppression"
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default PartnerDocumentTable;
